const BackgroundGrid = () => {
    return (
        <div className="full-width">
            <div className="grid-linear1"></div>
            <div className="grid-linear2"></div>
            <div className="grid-linear3"></div>
        </div>
    )
}

export default BackgroundGrid;